import * as types from '../../../../types/masters/route/route/routeMasterTypes';
import * as api from '../../../../../api/masters/route/route/routeMasterApi';

export const fetchRoutes = () => async (dispatch) => {
  dispatch({ type: types.FETCH_ROUTE_REQUEST });
  try {
    const data = await api.fetchRoutes();
    dispatch({ type: types.FETCH_ROUTE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_ROUTE_FAILURE, payload: error.message });
  }
};

export const addRoute = (route) => async (dispatch) => {
  try {
    const res = await api.addRoute(route);
    dispatch({ type: types.ADD_ROUTE_SUCCESS, payload: res });
    dispatch(fetchRoutes());
  } catch (error) {
    dispatch({ type: types.ROUTE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateRoute = (id, route) => async (dispatch) => {
  try {
    const res = await api.updateRoute(id, route);
    dispatch({ type: types.UPDATE_ROUTE_SUCCESS, payload: res });
    dispatch(fetchRoutes());
  } catch (error) {
    dispatch({ type: types.ROUTE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteRoute = (id) => async (dispatch) => {
  try {
    await api.deleteRoute(id);
    dispatch({ type: types.DELETE_ROUTE_SUCCESS, payload: id });
    dispatch(fetchRoutes());
  } catch (error) {
    dispatch({ type: types.ROUTE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setRouteEdit = (route) => ({
  type: types.SET_ROUTE_EDIT,
  payload: route,
});

export const clearRouteEdit = () => ({
  type: types.CLEAR_ROUTE_EDIT,
});